import React from 'react';
import ReactDOM from 'react-dom';

import iconSearch from '../assets/svg/icon-search.svg';
import iconClose from '../assets/svg/icon-cross.svg';

import {SideCart, Search, Modal} from './components';

const App = () => {
  if (window.theme.ecommerce) {
    const rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : '';
    const freeShippingBarSettings = {
      enabled: window.theme.freeShippingBar && window.theme.freeShippingBar.enabled,
      remainingTemplate: window.theme.strings.freeShippingBar.remaining,
      twoRemainingTemplate: window.theme.strings.freeShippingBar.twoRemaining,
      oneRemainingTemplate: window.theme.strings.freeShippingBar.oneRemaining,
      reachedTemplate: window.theme.strings.freeShippingBar.reached,
      serviceOne: window.theme.freeShippingBar.serviceOne,
      serviceTwo:
        window.theme.freeShippingBar && window.theme.freeShippingBar.serviceTwo
          ? window.theme.freeShippingBar.serviceTwo
          : null,
      thresholdOne: Number(window.theme.freeShippingBar.thresholdOne) * 100,
      thresholdTwo:
        window.theme.freeShippingBar && window.theme.freeShippingBar.thresholdTwo
          ? Number(window.theme.freeShippingBar.thresholdTwo) * 100
          : null,
      linkOne: window.theme.freeShippingBar.linkOne,
      linkTwo:
        window.theme.freeShippingBar && window.theme.freeShippingBar.linkTwo
          ? window.theme.freeShippingBar.linkTwo
          : null,
    };

    ReactDOM.render(
      <SideCart rootUrl={rootUrl} freeShippingBarSettings={freeShippingBarSettings} />,
      document.querySelector('#react-side-cart')
    );
  }

  const headerSearchEl = document.querySelector('#react-search-modal');
  if (headerSearchEl && window.theme.searchSettings.enableInstantSearch) {
    ReactDOM.render(
      <Modal
        size="full-screen"
        triggerLabel={
          <>
            <span dangerouslySetInnerHTML={{__html: iconSearch}} />
            <span class="visually-hidden">{window.theme.strings.search.search}</span>
          </>
        }
        closeLabel={window.theme.strings.search.close}
        className="search-modal"
        classNameTrigger="search-modal__trigger"
        container={document.querySelector('.header-section')}
        toggleClass="search"
        toggleEvent="toggleSearch"
        closeEvent="closeSearch"
      >
        <Search
          placeholder={window.theme.strings.search.placeholder}
          rootUrl={window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl}
          resources={{
            type: window.theme.searchSettings.types.join(','),
            limit: window.theme.searchSettings.limit,
          }}
          unavailableProducts={window.theme.searchSettings.unavailable_products}
          enableInstantSearch={window.theme.searchSettings.enableInstantSearch}
          showSearchSuggestions={window.theme.searchSettings.showSearchSuggestions}
          searchSuggestionsTitle={window.theme.strings.search.topSearches}
          searchSuggestions={window.theme.searchSettings.searchSuggestions}
          resultMoneyFormat={window.theme.moneyFormat}
          searchIcon={
            <>
              <span className="search-icon" dangerouslySetInnerHTML={{__html: iconSearch}} />
            </>
          }
          clearIcon={
            <>
              <span dangerouslySetInnerHTML={{__html: iconClose}} />
            </>
          }
          typeProductsTitle={window.theme.strings.search.typeProducts}
          typeCollectionsTitle={window.theme.strings.search.typeCollections}
          typeArticlesTitle={window.theme.strings.search.typeArticles}
          typePagesTitle={window.theme.strings.search.typePages}
          viewAllString={window.theme.strings.search.viewAll}
        />
      </Modal>,
      headerSearchEl
    );
  }

  const searchPageEl = document.querySelector('#react-search-results');
  if (searchPageEl && window.theme.searchSettings.enableInstantSearch) {
    ReactDOM.render(
      <Search
        placeholder={window.theme.strings.search.placeholder}
        rootUrl={window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl}
        resources={{
          type: window.theme.searchSettings.types.join(','),
          limit: window.theme.searchSettings.limit,
        }}
        unavailableProducts={window.theme.searchSettings.unavailable_products}
        enableInstantSearch={window.theme.searchSettings.enableInstantSearch}
        showSearchSuggestions={window.theme.searchSettings.showSearchSuggestions}
        searchSuggestionsTitle={window.theme.strings.search.topSearches}
        searchSuggestions={window.theme.searchSettings.searchSuggestions}
        resultMoneyFormat={window.theme.moneyFormat}
        searchIcon={
          <>
            <span className="search-icon" dangerouslySetInnerHTML={{__html: iconSearch}} />
          </>
        }
        clearIcon={
          <>
            <span dangerouslySetInnerHTML={{__html: iconClose}} />
          </>
        }
        helpText={window.theme.strings.search.helpText}
        typeProductsTitle={window.theme.strings.search.typeProducts}
        typeCollectionsTitle={window.theme.strings.search.typeCollections}
        typeArticlesTitle={window.theme.strings.search.typeArticles}
        typePagesTitle={window.theme.strings.search.typePages}
        viewAllString={window.theme.strings.search.viewAll}
      />,
      searchPageEl
    );
  }
};

export default App;
